import React from 'react';
import Modal from '../../../../../../components/Modal';
import MLButton from '../../../../../../components/MLButton/MLButton';
import PropTypes from 'prop-types';
import s from './GRSAIDisableModal.module.css';

const GRSAIDisableModal = ({ open, disableAiSummaries, onCancel }) => {
  return (
    <Modal
      open={open}
      onClosed={onCancel}
      data-test-id="Insights_grs_summaries_disable_modal"
      closeIcon={true}
      closeIconTestId="Insights_grs_summaries_close_disable_modal_x_btn"
    >
      <Modal.Header data-test-id="Insights_grs_summaries_disable_modal_header">
        Disable Summaries for GRS Responses
      </Modal.Header>
      <Modal.Content>
        <span className={s.boldText}>
          Are you sure you want to disable the summaries of student responses?
        </span>
        <br />
        You can opt back in at any time.
      </Modal.Content>
      <Modal.Footer className={s.noBorderFooter}>
        <MLButton
          btnType="secondary"
          testId="Insights_grs_summaries_cancel_btn_disable_modal"
          btnText="Cancel"
          onClick={onCancel}
        />
        <MLButton
          btnType="primaryDanger"
          testId="Insights_grs_summaries_confirm_btn_disable_modal"
          btnText="Disable Summaries"
          onClick={disableAiSummaries}
        />
      </Modal.Footer>
    </Modal>
  );
};

GRSAIDisableModal.propTypes = {
  open: PropTypes.bool.isRequired,
  disableAiSummaries: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default GRSAIDisableModal;
